<template>
    <div class="custom-box lessSpace">
        <div class="inc-tabs">
            <div class="tabs-header">
                <div class="tabs" :class="{ 'is-active': companiesDropdown }">
                    <span
                        v-if="companySelected"
                        v-for="company in companies"
                        @click="selectCompany(company)"
                        :class="{
                            active: companySelected.post.ID === company.ID,
                        }"
                        class="tab"
                        >{{ company.post_title }}</span
                    >
                </div>
                <span
                    class="opentabs"
                    @click="companiesDropdown = !companiesDropdown"
                    ><i class="fa fa-angle-down fa-dropdown"></i
                ></span>
            </div>
            <div class="tab_content">
                <div class="tab_item">
                    <div class="switch-header">
                        <a
                            href="#"
                            @click="toggleForm('public')"
                            :class="{ active: form.name === 'public' }"
                            class="co1-switch switch"
                            >Public</a
                        >
                        <a
                            href="#"
                            @click="toggleForm('private')"
                            :class="{ active: form.name === 'private' }"
                            class="co1-switch switch"
                            >Private</a
                        >
                    </div>
                    <div class="co1-switch-content active">
                        <component
                            v-if="companySelected"
                            v-bind:is="form.component"
                            :company="companySelected"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyProfilePublicForm from "@/components/domain/my-profile/company-profile-form/company-profile-public-form.vue";
import CompanyProfilePrivateForm from "@/components/domain/my-profile/company-profile-form/company-profile-private-form.vue";
import { getCompanies, getCompany } from "@/helpers/user";

const forms = {
    public: {
        name: "public",
        component: "CompanyProfilePublicForm",
    },
    private: {
        name: "private",
        component: "CompanyProfilePrivateForm",
    },
};

export default {
    data() {
        return {
            form: forms.public,
            companiesDropdown: false,
            companySelected: null,
            companies: [],
        };
    },
    components: {
        CompanyProfilePublicForm,
        CompanyProfilePrivateForm,
    },
    methods: {
        toggleForm(form) {
            if (Object.keys(forms).includes(form)) {
                this.form = forms[form];
            }
        },
        async selectCompany(company) {
            this.companySelected = await getCompany(company.ID);
        },
    },
    async mounted() {
        this.companies = await getCompanies();
        const company = this.companies.slice(0, 1).shift();
        this.companySelected = await getCompany(company.ID);
    },
};
</script>

<style></style>
